import "./style.css";
import DaonLogo from "../DaonLogo";
import Version from "../Version";
import ApplicationProgressBar from "../ApplicationProgressBar";
import ProcessingOverlay from "../ProcessingOverlay";

function PageContent({
  toggleLoading,
  children,
  type,
  showVersion,
  progressBar,
  progressPercentage,
}) {
  return (
    <ProcessingOverlay toggleLoading={toggleLoading}>
      {progressBar && (
        <ApplicationProgressBar progressPercentage={progressPercentage} />
      )}
      {type === "capture" ? (
        <div className="page-capture">{children}</div>
      ) : (
        <div id="page-content" className="page-content">
          <div className="m-20">{children}</div>
          <DaonLogo />
          {showVersion && <Version />}
        </div>
      )}
    </ProcessingOverlay>
  );
}

export default PageContent;
